export default __webpack_public_path__ + "static/media/php.eeca8d8c.svg";